<template>
  <div class="options-divider">
    <hr class="options-divider__left-line">
    <slot name="text" />
    <hr class="options-divider__right-line">
  </div>
</template>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.options-divider {
  .ds1-mv-2();
  .ds1-flex-vertical-center();
  width: 100%;
  display: flex;
  
  .options-divider__left-line, .options-divider__right-line {
    .ds1-mh-3();
    border-top: @DS1-UTD-GRAY-SINGLE-BORDER;
    flex: 1;
  }
}
</style>